<template>
  <IndicatorWrapper class="digital-evol-line" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters ref="textComponent" textKey="digital_evol_ratio_text_with_filters" :textData="dynamicTextData" v-model="currentFilters"></TextWithFilters>
    </div>
    <div class="bottom">
      <DigitalLinesChart 
        :data="indicatorData.evolutive" 
        :status="status" 
        :sector="currentFilters.custom_sects_digital_evol" 
        :compareData="indicatorData.compare_data"
        @changeSector="changeSector"></DigitalLinesChart>
      <ChartLegend :items="legendItems"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="digital_evol_ratio_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indDynamicText from '@/mixins/indDynamicText'
import indData from '@/mixins/indData'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import DigitalLinesChart from '@/components/IndicatorCards/parts/charts/DigitalLinesChart'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'
import data from '@/assets/fake_data/generics/evol_online_sector_month.json'
import data2 from '@/assets/fake_data/generics/evol_online_sector_month2.json'
import {capitalize} from '@/utils/textUtils'
import moment from 'moment';

export default {
  name: 'DigitalEvolRatio',

  mixins: [indData, indDynamicText],

  components: {
    TextWithFilters,
    ChartDescription,
    DigitalLinesChart,
    IndicatorWrapper,
    ChartLegend
  },
  computed: {
    // evolutiveStatus () {
    //   // return (!this.indicatorData['evolutive'] || this.$asyncComputed['asc_evolutive'].updating) ? {status:'fetching'} : {status:'ready'}
    //   if(this.$asyncComputed['asc_evolutive'].updating) return {status:'fetching'}
    //   else if(!this.indicatorData['evolutive']) return {status:'no-data'}
    //   else return {status:'ready'}
    // },
    indicatorData() {
      return {
        evolutive: {
          required: true,
          get () {
            return Api.getIndicatorData('evol_online_sector_month', this.currentFilters)
            /*return new Promise(res=>{
              res(data)
            })*/
            // if(Math.random()>0.5) return new Promise(res=>res(data))
            // else return new Promise(res=>res(data2))
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('evol_online_sector_month',this.currentFilters, {
               node: this.compareNodeInfo,
               avoidCancel: true
            }) :
            Promise.resolve(false)
            /*return this.isCompareMode ? new Promise(res=>{
              res(data2)
            }) : 
            Promise.resolve(false)*/
          }
        }
      }
    },
    dynamicTextData () {
      let evolData = this.indicatorData.evolutive && this.indicatorData.evolutive.data[0] && this.indicatorData.evolutive.data[0].data
      let customSectors = evolData && evolData.map((o)=>({value:o.id,label:this.t(o.id)}))
      if(customSectors){
        customSectors.sort((a,b)=>{
          if(a.value==='commerce-sector-total') return -1
          else if (b.value==='commerce-sector-total') return 1
          else return a.label < b.label ? -1 : 1
        })  
      }
      
      let firstMonth, lastMonth, sectorData
      if(evolData) {
        sectorData = evolData.find((d)=>d.id===(this.currentFilters.custom_sects_digital_evol || 'commerce-sector-total'))
        if(sectorData){
          sectorData = sectorData.data.filter((d)=>d.value)
          firstMonth = sectorData[0]
          lastMonth = sectorData[sectorData.length-1]
        }
      }
      return [
        {
          type: 'select',
          id: 'custom_sects_digital_evol',
          options: customSectors // || [this.currentFilters.custom_sects_digital_evol]
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: firstMonth ? firstMonth.value : '--',
          unit: '%'
        },
        {
          type: 'value',
          id: 'MONTH_1',
          value: firstMonth ? capitalize(moment(firstMonth.valueDate).format('MMMM')) : '--',
        },
        {
          type: 'value',
          id: 'VALUE_2',
          value: lastMonth ? lastMonth.value : '--',
          unit: '%'
        },
        {
          type: 'value',
          id: 'MONTH_2',
          value: lastMonth ? capitalize(moment(lastMonth.valueDate).format('MMMM')) : '--',
        }
      ]
    },
    legendItems () {
      let leg 
      if(this.isCompareMode){
        leg = [
          {
            'label': this.nodeInfo.value
          },
          {
            'label': this.compareNodeInfo.value,
            'class': 'compare'
          }
        ]
      } else if (this.currentFilters.custom_sects_digital_evol==='commerce-sector-total' || this.currentFilters.custom_sects_digital_evol==='' || !this.currentFilters.custom_sects_digital_evol){
        leg = [{
            'label': this.t('commerce-sector-total-sectors'),
            'class': 'sector-all-blue'
          }]
      } else{
        leg = [
          {
            'label':  this.t(this.currentFilters.custom_sects_digital_evol),
            'class': 'sector-current'
          },
          {
            'label': this.t('commerce-sector-total-sectors'),
            'class': 'sector-all'
          }
        ]
      } 
      if(this.isFetching) {
        leg[0].label += ' (Calculando)'
      } else if (!this.hasData) {
        leg[0].label += ' (No hay datos)'
      }
      if(leg[1]){
        if(this.isFetchingCompare) {
          leg[1].label += ' (Calculando)'
        } else if (!this.hasDataCompare) {
          leg[1].label += ' (No hay datos)'
        }
      }


      return leg
    },
  },
  methods:{
    changeSector(sectorId){
      this.currentFilters = {...this.currentFilters, custom_sects_digital_evol: sectorId}
    }
  }
}
</script>

<style lang="stylus" scoped>
.digital-evol-line
  .bottom
    .desktop &
      margin-top: vh(-30px)
</style>